<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form  [form]="formFilter">
        </sm-form>
        <p-button class="mt-2" icon="fas fa-circle-down" label="Holen" (onClick)="get()"></p-button>
        <p-button class="ml-2" icon="fas fa-circle-down" label="Alle Holen & Log Rest" (onClick)="getAll()"></p-button>
    </p-panel>
    <div class="flex-item-fill flex-col height100p">
        <sm-toolbar>
            <p-checkbox class="mr-3" label="Variablen entrollen" name="unrollVariables" [(ngModel)]="unrollVariables" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>                    
        </sm-toolbar>
        <sm-table2 *ngIf="table != null" class="flex-item-fill height100p" [data]="table"></sm-table2>
    </div>
</div>
<app-progressor-overlay [progressor]="progressor.value"></app-progressor-overlay>
